(() => {
  window.bfBlogSharing?.abort();
  const lifecycle = new AbortController();
  const roots = new Map();
  const listen = (target, type, handler, signal = lifecycle.signal) => target.addEventListener(type, handler, { signal });

  function initialize(root) {
    roots.get(root)?.abort();
    const controller = new AbortController();
    roots.set(root, controller);
    const top = root.matches('details.bf-share--top');
    const trigger = top ? root.querySelector(':scope > summary') : null;
    const status = root.querySelector('[data-bf-share-status]');
    const url = root.dataset.shareUrl;
    const title = root.dataset.shareTitle;
    let feedbackTimer;

    function clearFeedback() {
      clearTimeout(feedbackTimer);
      if (status) status.textContent = '';
    }

    function close(restoreFocus = false) {
      if (!top || !root.open) return;
      root.open = false;
      if (restoreFocus) trigger?.focus({ preventScroll: true });
    }

    function openFallback() {
      document.querySelectorAll('details.bf-share--top[open]').forEach(other => { if (other !== root) other.open = false; });
      root.open = true;
      root.querySelector('.bf-share-action')?.focus({ preventScroll: true });
    }

    if (trigger) {
      listen(trigger, 'click', async event => {
        if (!window.matchMedia('(max-width: 700px)').matches || typeof navigator.share !== 'function') return;
        const data = { title, url };
        if (typeof navigator.canShare === 'function' && !navigator.canShare(data)) return;
        event.preventDefault();
        root.open = false;
        try {
          await navigator.share(data);
        } catch (error) {
          if (error?.name !== 'AbortError') openFallback();
        }
      }, controller.signal);
      listen(root, 'toggle', () => {
        if (!root.open) return;
        document.querySelectorAll('details.bf-share--top[open]').forEach(other => { if (other !== root) other.open = false; });
      }, controller.signal);
      listen(document, 'pointerdown', event => { if (!root.contains(event.target)) close(); }, controller.signal);
      listen(document, 'focusin', event => { if (!root.contains(event.target)) close(); }, controller.signal);
    }

    listen(root, 'keydown', event => {
      if (event.key !== 'Escape') return;
      const copy = root.querySelector('[data-bf-share-copy][open]');
      if (copy) {
        copy.open = false;
        copy.querySelector('summary')?.focus({ preventScroll: true });
        event.preventDefault();
      } else if (top && root.open) {
        close(true);
        event.preventDefault();
      }
    }, controller.signal);

    root.querySelectorAll('[data-bf-share-copy]').forEach(copy => {
      const summary = copy.querySelector('summary');
      const input = copy.querySelector('[data-bf-share-url]');
      listen(summary, 'click', async event => {
        event.preventDefault();
        clearFeedback();
        if (copy.open) {
          copy.open = false;
          return;
        }
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(url);
          if (controller.signal.aborted) return;
          if (status) status.textContent = root.dataset.copySuccess;
          feedbackTimer = setTimeout(clearFeedback, 5000);
        } catch {
          if (controller.signal.aborted) return;
          copy.open = true;
          input?.focus({ preventScroll: true });
          input?.select();
          if (status) status.textContent = root.dataset.copyManual;
        }
      }, controller.signal);
      listen(input, 'click', () => input.select(), controller.signal);
    });

    listen(controller.signal, 'abort', () => clearTimeout(feedbackTimer));
  }

  function scan(scope = document) {
    if (scope instanceof Element && scope.matches('[data-bf-share]')) initialize(scope);
    scope.querySelectorAll('[data-bf-share]').forEach(initialize);
  }

  listen(document, 'shopify:section:load', event => scan(event.target));
  listen(document, 'shopify:section:unload', event => {
    for (const [root, controller] of roots) {
      if (event.target.contains(root)) { controller.abort(); roots.delete(root); }
    }
  });
  lifecycle.signal.addEventListener('abort', () => {
    for (const controller of roots.values()) controller.abort();
    roots.clear();
  }, { once: true });
  window.bfBlogSharing = lifecycle;
  scan();
})();
